export default function() {
  return Math.random();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/defaultSource.js
// module id = ./node_modules/d3-random/src/defaultSource.js
// module chunks = 54